import { ulid } from 'ulid';
import type {
	CreateVoucherInput,
	UpdateVoucherInput
} from '@/graphql/generated';
import { VoucherFormSubmitData } from './voucher-form';

const buildVoucherInput = (
	formData: VoucherFormSubmitData,
	voucherId: string
): CreateVoucherInput | UpdateVoucherInput => {
	return {
		voucherId,
		campaignId: formData.campaignId || undefined,
		name: formData.name?.trim() || undefined,
		code: formData.code,
		isAdHoc: formData.isAdHoc,
		isCustomerSpecific: formData.isCustomerSpecific,
		customerId: formData.customerId || undefined,
		tariffBindingRequired: formData.tariffBindingRequired,
		tariffId: formData.tariffId || undefined,
		voucherDiscountTypeId: formData.voucherDiscountTypeId,
		discountValue: formData.discountValue || undefined,
		maxDiscountAmount: formData.maxDiscountAmount || undefined,
		usageLimit: formData.usageLimit || undefined,
		isActive: formData.isActive,
		validUntilDate: formData.validUntilDate
	};
};

export const buildCreateVoucherInput = (
	formData: VoucherFormSubmitData,
	voucherId: string
): CreateVoucherInput => {
	return buildVoucherInput(formData, voucherId) as CreateVoucherInput;
};

export const buildUpdateVoucherInput = (
	formData: VoucherFormSubmitData,
	voucherId: string
): UpdateVoucherInput => {
	return buildVoucherInput(formData, voucherId) as UpdateVoucherInput;
};

export const generateIdempotentVoucherId = (): string => {
	return ulid();
};
